import PropTypes from 'prop-types';
import './PlatformSection.css';

const ChallengesSection = ({ 
  title, 
  highlightedText, 
  description, 
  cards,
  // backgroundColor = '#f7fafc',
  showToday = false
}) => {
  return (
    <section className="py-16 md:py-20">
      <div className="container mx-auto px-4">
        {/* Header Section */}
        <div className="text-center mb-12 max-w-4xl mx-auto">
          <h2 className="  font-bold text-gray-800 mb-6">
            <span className=''>{title}{' '}</span>
            <span className='secondary-text'>
              {highlightedText}
            </span>
            <span className=''>{showToday && ' Today'}</span>
          </h2>
          <p className="   leading-relaxed">
            {description}
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 max-w-6xl mx-auto">
          {cards.map((card, index) => (
            <div key={index} className="flip-card-container">
              <div className="flip-card">
                {/* Front Side */}
                <div className="flip-card-front">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="card-image"
                  />
                  {/* <div className="card-overlay"></div> */}
                  <div className="card-content">
                    <h3 className="card-title">{card.title}</h3>
                  </div>
                </div>

                {/* Back Side */}
                <div 
                  className="flip-card-back primary-bg"
                >
                  <div className="back-content">
                    {card.description && (
                      <p className="back-description">{card.description}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

ChallengesSection.propTypes = {
  title: PropTypes.string.isRequired,
  highlightedText: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
    })
  ).isRequired,
  backgroundColor: PropTypes.string,
  showToday: PropTypes.bool,
};

export default ChallengesSection;